import AccountAuth from '@/api/accountAuth'

const actions = {
  GET({ commit }, payload) {
    AccountAuth.get(function(response) {
      commit('INITIALIZE', { auth: response.data })
    })
  },
}

export default actions
